import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@mui/material';

import { differenceInMonths } from 'date-fns';

export interface MonthsOwnedCellProps {
  startDate: Date;
}

export const MonthsOwnedCell = ({ startDate }: MonthsOwnedCellProps) => {
  const diff = useMemo(() => differenceInMonths(new Date(), startDate), [startDate]);

  return (
    <Typography variant="body2" component="span">
      ({diff < 1 && '<'}
      <FormattedMessage
        id="number-of-months"
        defaultMessage="{months} {months, plural, one {Month} other {Months}}"
        values={{ months: Math.max(Math.round(diff), 1) }}
      />
      )
    </Typography>
  );
};
